const iconCardsBlock = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.icon-cards-block').forEach((target: HTMLElement) => {
      this.handleIconCardsBlock(target)
    })
  },

  handleIconCardsBlock(target): void {
    const el = {
      iconCardsColumn: target.querySelector('.icon-cards-block__column'),
      previousSection: target.previousElementSibling,
    }

    const method = {
      init(): void {
        method.adjustBlockWidth()
        window.addEventListener('resize', method.adjustBlockWidth)
      },

      adjustBlockWidth(): void {
        if (el.previousSection && target.classList.contains('icon-cards-block--small')) {
          target.classList.remove('icon-cards-block--small-wide')

          const previousSectionGridColumn = el.previousSection.querySelector('.container > .grid')?.firstElementChild

          if (previousSectionGridColumn) {
            if (previousSectionGridColumn.offsetWidth > el.iconCardsColumn.offsetWidth) {
              target.classList.add('icon-cards-block--small-wide')
            }
          }
        }
      },
    }

    method.init()
  },
}

export default iconCardsBlock
